import {
  airDisruptionApi,
  type CipherText,
  type DisruptionFailure,
  type PollFulfillSuccess,
  RebookPollFulfillResponseEnum,
  RebookScheduleFulfillResponseEnum,
} from "@b2bportal/air-disruption-api";
import type { FlightsRebookState } from "@b2bportal/core-flights-rebook";
import {
  makeAxiosRequest,
  polling,
  type RichError,
} from "@b2bportal/core-utilities";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const api = airDisruptionApi(axios);

export const performRebookFulfill = createAsyncThunk<
  PollFulfillSuccess,
  { contractId: string; token: CipherText },
  { state: FlightsRebookState; rejectValue: RichError<DisruptionFailure> } //RichError<DisruptionFailure> }
>(
  "flights-rebook/performRebookFulfill",
  async ({ contractId, token }, thunkAPI) => {
    const schedule = makeAxiosRequest(
      api.apiV0DisruptionExerciseRebookFulfillSchedulePost({
        contractId,
        token,
      }),
      {
        discriminator: "RebookScheduleFulfillResponse",
        success: RebookScheduleFulfillResponseEnum.ScheduleFulfillSuccess,
        failure: RebookScheduleFulfillResponseEnum.ScheduleFulfillFailure,
      },
      { failure: (error) => error.reason }
    );

    const result = await schedule.andThen((sched) =>
      polling.poll(
        () =>
          api.apiV0DisruptionExerciseRebookFulfillPollPost({
            contractId: contractId,
            token: sched.token,
          }),
        {
          discriminator: "RebookPollFulfillResponse",
          success: RebookPollFulfillResponseEnum.PollFulfillSuccess,
          failure: RebookPollFulfillResponseEnum.PollFulfillFailure,
          pending: RebookPollFulfillResponseEnum.PollFulfillPending,
        },
        { failure: (error) => error.reason }
      )
    );

    if (result.isErr()) {
      return thunkAPI.rejectWithValue(result.error);
    }
    return result.value;
  }
);
